import { ObjectSchema, objectSchema } from "utils/object-methods";
import { DigitacaoCLTProps } from ".";
import { fieldValidation } from "utils/field-validation";
import { Attendance } from "components/atendimentos-components/atendimento-form/types";
import { copyAttendanceDataToDigitacao } from "components/atendimentos-components/atendimento-form/step-form/tabs-components/digitacao-fields/parts/const";
import { factaCitiesArray } from "components/atendimentos-components/atendimento-form/step-form/tabs-components/digitacao-fields/parts/cities-array";
import { phoneSeparate } from "../../simulacao-fields/utils";

export const validateDigitacaoCLT = (modalData: Partial<DigitacaoCLTProps>) => {
  let schema: ObjectSchema<DigitacaoCLTProps> = {
    bancoDigitacao: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    cpf: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    name: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    phoneDDD1: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    phoneNumber1: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    documentNumber: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    bankNumber: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    bankAgency: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    bankAccountNumber: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    bankDigit: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    bankType: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    gender: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    addressStreet1: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    addressNeigh1: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    addressCity1: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    addressStateCode1: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    addressZipCode1: (value) => {
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    mothersName: (value) => {
      if (modalData.bancoDigitacao !== "FACTA") return { valid: true }
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    sellerCode: (value) => {
      if (modalData.bancoDigitacao !== "FACTA") return { valid: true }
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    masterCode: (value) => {
      if (modalData.bancoDigitacao !== "FACTA") return { valid: true }
      return { valid: true, format: value || null };
    },
    birthDay: (value) => {
      if (modalData.bancoDigitacao !== "TWO_S_CONSIG") return { valid: true }
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    sellerCpf: (value) => {
      if (modalData.bancoDigitacao !== "TWO_S_CONSIG") return { valid: true }
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    email1: (value) => {
      if (modalData.bancoDigitacao !== "TWO_S_CONSIG") return { valid: true }
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    emailEmployer1: (value) => {
      if (modalData.bancoDigitacao !== "TWO_S_CONSIG") return { valid: true }
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    phoneDDDEmployer1: (value) => {
      if (modalData.bancoDigitacao !== "TWO_S_CONSIG") return { valid: true }
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    },
    phoneNumberEmployer1: (value) => {
      if (modalData.bancoDigitacao !== "TWO_S_CONSIG") return { valid: true }
      const { isValid } = fieldValidation({ value }).required();
      return { valid: isValid, message: "preencha o campo corretamente" };
    }
  };

  return objectSchema(schema, modalData);
};

export function copyAttendanceDataToDigitacaoConsigCLT(
  attendance: Attendance
): Partial<DigitacaoCLTProps> {
  const possiveisCidades = factaCitiesArray.filter((crr) => {
    return (
      crr.value.uf === attendance.uf &&
      crr.value.cityName.includes(attendance.cidade!)
    );
  });

  const gender =
    attendance.sexo === "FEMININO"
      ? "F"
      : attendance.sexo === "MASCULINO"
      ? "M"
      : undefined;

  const bankType = {
    CONTA_CORRENTE: "CONTA_CORRENTE_INDIVIDUAL",
    POUPANCA: "CONTA_POUPANCA_INDIVIDUAL",
  }[attendance.tipoContaPagamento ?? ""];

  const rawResult: Partial<DigitacaoCLTProps> = {
    name: attendance.nome,
    cpf: attendance.cpf as string | undefined,
    addressNeigh1: attendance.bairro as string | undefined,
    addressStreet1: attendance.endereco as string | undefined,
    addressZipCode1: attendance.cep as string | undefined,
    bankNumber: attendance.codBancoPagamento as string | undefined,
    documentNumber: attendance.documento as string | undefined,
    gender,
    mothersName: attendance.nomeMae as string | undefined,
    phoneDDD1: phoneSeparate({
      completedNumber: attendance.telefoneResidencial as string | undefined,
    }).ddd,
    phoneNumber1: phoneSeparate({
      completedNumber: attendance.telefoneResidencial as string | undefined,
    }).number,
    bankAccountNumber: attendance.contaPagamento as string | undefined,
    bankAgency: attendance.agenciaPagamento as string | undefined,
    bankDigit: attendance.dvContaPagamento as string | undefined,
    bankType,
  };

  if (possiveisCidades.length === 1) {
    rawResult.addressCity1 = possiveisCidades[0].value.cityName;
    rawResult.addressStateCode1 = possiveisCidades[0].value.uf;
  }

  const parsed = Object.entries(rawResult).reduce((acc, [k, v]) => {
    if (v != null) acc[k as keyof Partial<DigitacaoCLTProps>] = v;
    return acc;
  }, {} as Partial<DigitacaoCLTProps>);

  return parsed;
}
